import api from './api';

export const getListings = async () => {
  try {
    const response = await api.get('/api/listings');
    return response.data.data; // Access the data property from the response
  } catch (error) {
    console.error('Error fetching listings:', error);
    throw error;
  }
};

export const getUserListings = async () => {
  try {
    const response = await api.get('/api/user/listings');
    return response.data;
  } catch (error) {
    console.error('Error fetching user listings:', error);
    throw error;
  }
};

export const getListing = async (id) => {
  try {
    const response = await api.get(`/api/listings/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching listing:', error);
    throw error;
  }
};

export const createListing = async (listingData) => {
  try {
    const formData = new FormData();
    
    // Append all listing data to FormData
    Object.keys(listingData).forEach(key => {
      if (key === 'image' && listingData[key]) {
        formData.append('image', listingData[key]);
      } else {
        formData.append(key, listingData[key]);
      }
    });

    const response = await api.post('/api/listings', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating listing:', error);
    throw error;
  }
};

export const updateListing = async (id, listingData) => {
  try {
    const formData = new FormData();
    
    // Append all listing data to FormData
    Object.keys(listingData).forEach(key => {
      if (key === 'image' && listingData[key]) {
        formData.append('image', listingData[key]);
      } else {
        formData.append(key, listingData[key]);
      }
    });

    const response = await api.put(`/api/listings/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating listing:', error);
    throw error;
  }
};

export const deleteListing = async (id) => {
  try {
    const response = await api.delete(`/api/listings/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting listing:', error);
    throw error;
  }
}; 